import { render, staticRenderFns } from "./FallbackKeywords.vue?vue&type=template&id=6ce83b9a&"
import script from "./FallbackKeywords.vue?vue&type=script&lang=js&"
export * from "./FallbackKeywords.vue?vue&type=script&lang=js&"
import style0 from "./FallbackKeywords.vue?vue&type=style&index=0&id=6ce83b9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports